import { useApp } from 'contexts/app';
import { createContext, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';

const PageContext = createContext();

const PageProvider = (props) => {
    const { studentAccountUsers, currentAssignmentId, currentAssignment, studentSubmissions } = useApp();
    const history = useHistory();

    const [checked, setChecked] = useState([]);

    const studentSubmissionsGroupedByAccountUser = useMemo(() => {
        return studentAccountUsers?.map((accountUser) => {
            return {
                ...accountUser,
                submissions: studentSubmissions?.filter(
                    ({ owner_account_id }) => owner_account_id === accountUser.owner_account_id
                ),
            };
        });
    }, [studentAccountUsers, studentSubmissions]);

    const onClickBack = () => {
        history.push(`/assignments/${currentAssignmentId}`);
    };

    const onClickView = ({ owner_account_id }) => {
        const params = new URLSearchParams({ owner_account_id, type: 'formative' });
        history.push(`/assignments/${currentAssignmentId}/submissions?${params.toString()}`);
    };

    return (
        <PageContext.Provider
            value={{
                currentAssignment,
                studentSubmissionsGroupedByAccountUser,
                checked,
                setChecked,
                onClickBack,
                onClickView,
            }}
            {...props}
        />
    );
};

export { PageContext };
export default PageProvider;
